(function () {
  'use strict';

  customizationController.$inject = ["$element", "$timeout", "$filter", "productService"];
  angular
    .module('app.product.customization', [])

    .component('customization', {
      require: {
        productCtrl: '^^productDetail'
      },
      bindings: {
        model: '<',
        tooltip: '@'
      },
      templateUrl: '/Template/Product/ProductCustomization',
      controller: customizationController
    })

    .component('chequeCustomization', {
      require: {
        productCtrl: '^^productDetail'
      },
      bindings: {
        model: '<',
        tooltip: '@'
      },
      templateUrl: '/Template/Product/ProductChequeCustomization',
      controller: customizationController
    });

  /* @ngInject */
  function customizationController($element, $timeout, $filter, productService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.showTTCPrice = ctrl.productCtrl.showTTCPrice;
      ctrl.device = ctrl.productCtrl.device;
      $timeout(function () {
        var currentModel = productService.getProductCustomisation(ctrl.productCtrl.idGroup);
        if (currentModel) {
          ctrl.model = currentModel;
        } else {
          _.each(ctrl.model.Items, function (item) {
            if (!item.Group) {
              if (item.Field.CustomizationType === 1 && item.Field.Code.indexOf('Date') !== -1) {
                item.Field.isDate = true;
                item.Field.Value = new Date(new Date().setHours(23, 59));
                item.Field.reqPlaceholder = item.Field.Required ? ' *' : '';
              }
              if (item.Field.CustomizationType === 3) {
                _.each(item.Field.Items, function (option) {
                  option.content = option.Designation;
                  if (ctrl.showTTCPrice && option.AdditionalCostTTC) {
                    option.content = option.Designation + '<span class="small"> (+ ' + $filter('price')(option.AdditionalCostTTC, 'value') + ')</span>';
                    option.content = option.content.replace(/"/g, '\'');
                  }
                  if (!ctrl.showTTCPrice && option.AdditionalCostHT) {
                    option.content = option.Designation + '<span class="small"> (+ ' + $filter('price')(option.AdditionalCostHT, 'value', 'ht') + ')</span>';
                    option.content = option.content.replace(/"/g, '\'');
                  }
                });
              }
            }
            if (item.Group) {
              _.each(item.Group.Fields, function (field) {
                if (field.CustomizationType === 1 && field.Code.indexOf('Date') !== -1) {
                  field.isDate = true;
                  field.reqPlaceholder = field.Required ? ' *' : '';
                }
                if (field.CustomizationType === 3) {
                  _.each(field.Items, function (option) {
                    option.content = option.Designation;
                    if (ctrl.showTTCPrice && option.AdditionalCostTTC) {
                      option.content = option.Designation + '<span class="small"> (+ ' + $filter('price')(option.AdditionalCostTTC, 'value') + ')</span>';
                      option.content = option.content.replace(/"/g, '\'');
                    }
                    if (!ctrl.showTTCPrice && option.AdditionalCostHT) {
                      option.content = option.Designation + '<span class="small"> (+ ' + $filter('price')(option.AdditionalCostHT, 'value', 'ht') + ')</span>';
                      option.content = option.content.replace(/"/g, '\'');
                    }
                  });
                }
              });
            }
          });
        }
        refreshSelects();

        ctrl.update();
        ctrl.init = true;
      });

    };

    ctrl.dateOptions = {
      showWeeks: false,
      minDate: new Date(),
      yearRows: 2
    };
    ctrl.dateFormat = 'dd/MM/yyyy';

    ctrl.successfile = function (file, field) {
      field.Value = file.name;
      field.Comment = file.serverName;
      ctrl.update();
    };
    ctrl.removedfile = function (field) {
      field.Value = '';
      field.Comment = '';
      ctrl.update();
    };

    ctrl.update = function () {
      ctrl.productCtrl.setCustomization(ctrl.model, ctrl.tooltip);
    };

    // Functions

    function refreshSelects() {
      setTimeout(function () {
        $element.find('select.refresh').each(function (index, el) {
          $(el).selectpicker('refresh');
        });
      });
    }
  }
})();
